<template>
  <span class="type-heading-xs text-left font-bold"
    >{{ title }} arbetsgivare</span
  >
  <avtalat-table
    class="mx-auto table-fixed"
    :headings="columns"
    :striped="false"
  >
    <avtalat-table-row
      class="justify-center text-left"
      v-for="(arende, index) in arenden"
      :key="index"
    >
      <avtalat-table-cell>{{ arende.rubrik }}</avtalat-table-cell>
      <avtalat-table-cell class="w-[160px]">
        <a v-if="!arende.okopplat" :href="`/?q=${arende.id}`" target="_blank"
          >#{{ arende.id }}</a
        ><span v-else> #{{ arende.id }}</span></avtalat-table-cell
      >
      <avtalat-table-cell class="w-[288px]">{{
        arende.overlamnadTill
          ? LamnaOverTypeLabels[arende.overlamnadTill]
          : "Nej"
      }}</avtalat-table-cell>
      <avtalat-table-cell class="w-[160px]">{{
        formatDateToYYYYMMDD(
          props.sortedByCreatedAt ? arende.createdAt : arende.updatedAt,
        )
      }}</avtalat-table-cell>
      <avtalat-table-cell class="w-[96px]">
        <div class="flex justify-center">
          <KanalIcon v-if="arende.kanal" :kanal="arende.kanal" /><span v-else
            >Ingen kanal</span
          >
        </div></avtalat-table-cell
      >
    </avtalat-table-row>
  </avtalat-table>
  <div class="mt-xs flex justify-center">
    <div v-if="arenden.length === 0">
      Du har inga <span class="lowercase">{{ title }}</span>
    </div>
    <avtalat-button
      v-if="canFetchMoreArenden"
      v-on:click="fetch"
      style="color: teal; border-color: teal"
      small
      outlined
      color="blue"
      :loading="isLoading"
      >Visa fler <span class="lowercase">{{ title }}</span></avtalat-button
    >
  </div>
</template>

<script setup lang="ts">
import { LamnaOverTypeLabels } from "@/common/constants";
import { formatDateToYYYYMMDD } from "@/common/formatters";
import KanalIcon from "@/components/ui/KanalIcon.vue";
import type { Arbetsgivarearende } from "@/composables/KundserviceAppApiClient";

const props = defineProps<{
  title: string;
  columns: { content: string; disableSorting: boolean }[];
  arenden: Arbetsgivarearende[];
  isLoading: boolean;
  canFetchMoreArenden: boolean;
  sortedByCreatedAt: boolean;

  fetch: () => void;
}>();
</script>
